// app/javascript/projects/components/ProjectsDisplay.jsx
import React from 'react';
import BillingModalMainRenew from './BillingModalMainRenew';
import { formatSubscriptionEndDate, formatSubscriptionPrice } from '../../../utils/subscriptionUtils';

function BillingModalMainBillingActive ({ subscription = {} }) {
  return (<BillingModalMainRenew
      subscription={subscription}
    >
      <p>
        Your subscription will automatically renew on {formatSubscriptionEndDate(subscription.current_period_end)} and you'll be charged {formatSubscriptionPrice(subscription)}.
      </p>
  </BillingModalMainRenew>)
}

export default BillingModalMainBillingActive
